export const FlameSection = ({ intensity = 0 }) => {
    return (
        <div className="flex mr-1">
            <i
                aria-hidden
                className={`fas fa-fire mr-1 text-xs ${
                    intensity >= 1 ? 'text-yf-purple' : 'text-gray-600'
                }`}
            ></i>
            <i
                aria-hidden
                className={`fas fa-fire mr-1 text-xs ${
                    intensity >= 2 ? 'text-yf-purple' : 'text-gray-600'
                }`}
            ></i>
            <i
                aria-hidden
                className={`fas fa-fire mr-px text-xs ${
                    intensity === 3 ? 'text-yf-purple' : 'text-gray-600'
                }`}
            ></i>
        </div>
    )
}
